var $ = require('jquery'),
  ListModel = require('./models/ListModel'),
  MainContainer = require('./views/MainContainer'),
  QrCodeContainer = require('./views/QrCodeContainer'),
  FilterNav = require('./views/FilterNav'),
  detector = require('widgets/detector')

require('@173js/ui/preventEmptyHrefClick')

var win = $(window)

function setupPjaxFilter() {
  var listModel = new ListModel()

  var mainContainer = new MainContainer({
    el: $('.pn-game-all'),
    model: listModel,
  })
  mainContainer.render()

  var filterNav = new FilterNav({
    el: $('.pn-game-filter'),
    model: listModel,
  })

  filterNav.render()

  win.on('popstate', function () {
    listModel.trigger('changeRoute')
  })
}

$(function () {
  var qrCodeContainer = new QrCodeContainer({
    el: $('.pn-game-all'),
  })
  qrCodeContainer.render()

  if (!detector.hasPushState()) {
    return
  }
  setupPjaxFilter()
})
